import React, { Component } from 'react'
import { useNavigate, Link, json } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { TopVisaList } from '../../Services/VisaService';
import Autocomplete from 'react-autocomplete';
import { withTranslation } from 'react-i18next';
class Visa extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      TopVisaList: [],
      AllCountries: [],
    };
  }
 changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
    document.body.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
  };

  componentDidMount() {
    this.GetAllCountries({ Keyword: "" });
  }

  GetAllCountries(data) {
    TopVisaList(data).then((response) => {
      if (response.data.status) {
        this.setState({
          AllCountries: response.data.topVisaList,
        });
      }
    });
  }

  onChange = (event) => {
    const value = event.target.value;
    this.setState({ value });

    let data = {};
    data.keyword = value;
    this.getTopVisaList(data);
  };

  getTopVisaList(data) {
    TopVisaList(data).then((response) => {
      if (response.data.status) {
        this.setState({
          TopVisaList: response.data.topVisaList,
        });
      }
    });
  }

  gotoDetailsPage = (id) => {
    this.props.navigate(`/VisaDetails/${id}`);
  };

  render() {
    const { t } = this.props;
    const { value, TopVisaList, AllCountries } = this.state;
    const filteredItems = value.length > 0 ? TopVisaList.slice(0, 5) : [];

        const currencyMap = {
      IN: "₹",
      AE: "AED",
      SA: "SAR",
      QA: "QAR",
      OM: "OMR",
      BH: "BHD",
      KW: "KWD"
    };

    const defaultCountry = localStorage.getItem("selectedCountryCode");
    
    const currencySymbol = currencyMap[defaultCountry] || "";

    return (
      <div>
       <section className="vh-hero">
  {/* Background */}
  <div
    className="vh-hero__bg"
    style={{ backgroundImage: 'url("assets/img/visa-banner.jpg")' }}
  />
  <div className="vh-hero__dim" />

  {/* Decorative rings */}
  <div className="vh-hero__circle-1" />
  <div className="vh-hero__circle-2" />
  <div className="vh-hero__circle-3" />

  <div className="container">
    <div className="vh-hero__content">

      {/* Eyebrow pill */}
      <div className="vh-hero__pill">
        <span className="vh-hero__pill-dot" />
        {t("visa_title")}
      </div>

      {/* Title */}
      <h1 className="vh-hero__title">
       {t("visa_subtitle1")}<br />
        {t("visa_subtitle2")} <span className="vh-hero__title-accent">{t("visa_subtitle3")}</span>
      </h1>
      <p className="vh-hero__sub">
        {t("visa_subtitle4")}
      </p>

      {/* Search bar */}
      <div className="vh-search-outer">
        <div className="vh-search-box">

          {/* Left search icon */}
          <div className="vh-search-icon-left">
            <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18}
              fill="currentColor" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </div>

          {/* Autocomplete */}
          <Autocomplete
            getItemValue={(item) => String(item.countryId)}
            items={filteredItems}
            renderItem={(item, isHighlighted) => (
              <div className={`vh-autocomplete-item${isHighlighted ? ' vh-autocomplete-item--highlighted' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14}
                  fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>
                {item.countryName}
              </div>
            )}
            renderMenu={(items) => (
              <div className="vh-autocomplete-menu">{items}</div>
            )}
            inputProps={{
              placeholder: "Search country — Dubai, UK, Canada...",
            }}
            wrapperStyle={{ flex: 1, minWidth: 0, position: 'static' }}
            value={value}
            onChange={this.onChange}
            onSelect={(val) => this.gotoDetailsPage(val)}
          />

          {/* CTA button */}
         
        </div>
      </div>

      {/* Trust badges */}
      <div className="vh-trust-row">
        <div className="vh-trust-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13}
            fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm3.5 7.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.374.832l3 3.5a.5.5 0 0 0 .748-.664L7.246 7.5H11.5z" />
          </svg>
          {t("visa_subtitle5")}
        </div>
        <div className="vh-trust-sep" />
        <div className="vh-trust-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13}
            fill="currentColor" viewBox="0 0 16 16">
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
            <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z" />
          </svg>
          {t("visa_subtitle6")}
        </div>
        <div className="vh-trust-sep" />
        <div className="vh-trust-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13}
            fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
          </svg>
          {t("visa_subtitle7")}
        </div>
        <div className="vh-trust-sep" />
        <div className="vh-trust-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13}
            fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524z" />
          </svg>
          {t("visa_subtitle8")}
        </div>
      </div>

    </div>
  </div>
</section>
    {AllCountries.length > 0 && (
  <section className="vd-section">
    <div className="container">

      {/* ── Section Header ── */}
      <div className="vd-header">
        <span className="vd-eyebrow">{t("explore")}</span>
        <h2 className="vd-title">{t("v_dest_title")}</h2>
        <p className="vd-desc">
          {t("v_dest_desc")}
        </p>
      </div>

      {/* ── Destination Grid ── */}
      <div className="vd-grid">
        {AllCountries.map((item, index) => (
          <div
            key={index}
            className="vd-card"
            onClick={() => this.gotoDetailsPage(item.countryId)}
          >
            {/* Image */}
            <div className="vd-card__img-wrap">
              <img
                src={item.imageLocation || "/assets/img/visa_default_thumb.jpg"}
                className="vd-card__img"
                alt={item.countryName}
              />
              <div className="vd-card__img-overlay" />

              {/* Arrow on hover */}
              <div className="vd-card__arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13}
                  fill="currentColor" viewBox="0 0 16 16">
                  <path fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                </svg>
              </div>
            </div>

            {/* Body */}
            <div className="vd-card__body">
              <p className="vd-card__name">{item.countryName}</p>

              {item.amount > 0 ? (
                <div className="vd-card__price">
                  <span className="vd-card__price-label">from</span>
                  <span className="vd-card__price-amount">{currencySymbol} {" "} {item.amount}</span>
                </div>
              ) : (
                <p className="vd-card__price--contact">Contact us</p>
              )}
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
)}

  <section className="why-choose pt-50 pb-50">
  <div className="container">
    <h2 className="text-center mb-5 fw-bold">{t("why_choose_alhind_visa")}</h2>
   <div className="row g-4">
  {[
    { img: "visa-service.png", key: "visa_features.services" },
    { img: "visa-processing.png", key: "visa_features.experience" },
    { img: "worldwide.png", key: "visa_features.branches" },
    { img: "customer-service.png", key: "visa_features.assistance" },
    { img: "delivery.png", key: "visa_features.delivery" },
    { img: "safety.png", key: "visa_features.safety" },
  ].map((item, index) => (
    <div className="col-lg-4 col-md-6" key={index}>
      <div className="feature-card text-center">
        <div className="icon-box">
          {/* Using t() for the alt tag too for accessibility */}
          <img 
            src={`assets/img/visa-icons/${item.img}`} 
            alt={t(item.key)} 
            width={80} 
          />
        </div>
        {/* The translated title */}
        <h6>{t(item.key)}</h6>
      </div>
    </div>
  ))}
</div>
  </div>
</section>

   <div className="vp-section">
  <p className="vp-label">{t("how_it_works")}</p>
  <h2 className="vp-title">{t("visa_step_header")}</h2>
  <div className="vp-steps">
    <div className="vp-step">
      <div className="vp-card">
        <span className="vp-step-num">01</span>
        <div className="vp-icon-wrap">
          <svg
            className="vp-icon"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="rgba(255,255,255,0.9)"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1={16} y1={13} x2={8} y2={13} />
            <line x1={16} y1={17} x2={8} y2={17} />
            <polyline points="10 9 9 9 8 9" />
          </svg>
        </div>
        <p className="vp-step-title">{t("visa_step1")}</p>
        <p className="vp-step-desc">
          {t("visa_step1_desc")}
        </p>
        {/* <span className="vp-badge">5 minutes</span> */}
      </div>
    </div>
    <div className="vp-connector">
      <div className="vp-arrow" />
    </div>
    <div className="vp-step">
      <div className="vp-card">
        <span className="vp-step-num">02</span>
        <div className="vp-icon-wrap">
          <svg
            className="vp-icon"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="rgba(255,255,255,0.9)"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </div>
        <p className="vp-step-title">{t("visa_step2")}</p>
        <p className="vp-step-desc">
          {t("visa_step2_desc")}
        </p>
        {/* <span className="vp-badge">24–48 hrs</span> */}
      </div>
    </div>
    <div className="vp-connector">
      <div className="vp-arrow" />
    </div>
    <div className="vp-step">
      <div className="vp-card">
        <span className="vp-step-num">03</span>
        <div className="vp-icon-wrap">
          <svg
            className="vp-icon"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="rgba(255,255,255,0.9)"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x={2} y={4} width={20} height={16} rx={2} />
            <path d="M7 15s.5-4 5-4 5 4 5 4" />
            <circle cx={12} cy={8} r={2} />
          </svg>
        </div>
        <p className="vp-step-title">{t("visa_step3")}</p>
     <p className="vp-step-desc">
          {t("visa_step3_desc")}
        </p> 
        {/* <span className="vp-badge">Hassle-free</span> */}
      </div>
    </div>
  </div>
  <div className="vp-footer">
    <div>
     {t("trusted_by")}
    </div>
  
  </div>
</div>





        {/* Visa coming soon area starts */}
        {/* <div className="container">
        <h2 class="mb-2 mx-2 cs-title mt-5 text-center">Launching soon!</h2>
        <p className="cs-text text-center">We are currently developing the system for a better experience.<br/>Apologize for the inconvenience and thank you.</p>
        <div className="row align-items-center justify-content-center">
        <div className="col-lg-4 col-md-4">
       
        <img src="assets/img/visa-bg.webp" className="img-fluid" />
        </div>
        <div className="col-lg-6 col-md-6">
        <div className="card cs-card">
          <div className="card-title">
          <h4>For Visa Services and Enquiries Please contact us </h4>
          </div>
          <div className="card-body">
         
          <h4><img src="assets/img/support.svg" width={30}/> 0495 2389900</h4>
        <h4><img src="assets/img/email.svg" width={30}/> b2c@alhindonline.com</h4>
          </div>
        </div>
        </div>
        </div>

        </div>   */}

        {/* Visa coming soon area ends */}

      </div>
    )
  }
}

// function WithNavigate(props) {
//   let navigate = useNavigate();
//   return <Visa {...props} navigate={navigate} />;
// }

// export default WithNavigate;
const TranslatedHomePage = withTranslation()(Visa);
function WithNavigate(props) {
  let navigate = useNavigate();
  return <TranslatedHomePage {...props} navigate={navigate} />;
}

export default WithNavigate;
